define('appkit/module.loader',['require','exports','module','underscore','backbone.radio','./util/bind.radio'],function(require, exports, module) {
  var _ = require('underscore');
  var Radio = require('backbone.radio');
  var bindRadio = require('./util/bind.radio');

  var RADIO_REPLIES_KEY = 'radioRequests';
  var RADIO_EVENTS_KEY = 'radioEvents';

  var ModuleLoader = {

    loadModules: function(definedModules) {
      _.each(definedModules, function(exports, name) {
        ModuleLoader.loadModule(name, exports);
      });
    },

    loadModule: function(name, exports) {
      ModuleLoader.loadExports(exports);
      Radio.channel('moduleLoader').trigger('load', name, exports);
    },

    loadExports: function(exports) {
      ModuleLoader.processRadioEvents(exports);
      ModuleLoader.processRadioRequests(exports);
      if (_.has(exports, '__onLoad')) {
        exports.__onLoad.call(exports);
      }
    },

    processRadioEvents: function(target) {
      if (_.has(target, RADIO_EVENTS_KEY)) {
        bindRadio.bindEvents(target, _.result(target, RADIO_EVENTS_KEY));
      }
    },

    processRadioRequests: function(target) {
      if (_.has(target, RADIO_REPLIES_KEY)) {
        bindRadio.bindRequests(target, _.result(target, RADIO_REPLIES_KEY));
      }
      if (_.has(target, 'prototype') && _.has(target.prototype, RADIO_REPLIES_KEY)) {
        var radioRequests = _.result(target.prototype, RADIO_REPLIES_KEY);
        var extraToBind = {};
        _.each(radioRequests, function(value, key) {
          if (value === '@constructor') {
            delete target.prototype[RADIO_REPLIES_KEY][key];
            extraToBind[key] = _.constant(target);
          }
        });
        bindRadio.bindRequests(target, extraToBind);
      }
    }

  };

  module.exports = ModuleLoader;
});
